import { MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useCMS } from "../lib/cms";

export default function WhatsAppButton() {
  const brand = useCMS("brand", { whatsapp_link: "https://wa.me/447474759947" });
  const link = brand.whatsapp_link || "https://wa.me/447474759947";
  // Append a default greeting if no `?text` already present
  const href = link.includes("?")
    ? link
    : `${link}?text=${encodeURIComponent("Hello West London Stays — I'd like to enquire about a stay.")}`;
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setPulse(false), 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      data-testid="whatsapp-floating-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 group"
      aria-label="WhatsApp"
    >
      <span className="hidden sm:inline-block bg-black/85 backdrop-blur text-white text-xs tracking-wide px-4 py-2 border border-emerald/40 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300 whitespace-nowrap">
        Chat on WhatsApp
      </span>
      <span className="relative">
        {pulse && <span className="absolute inset-0 rounded-full bg-emerald animate-ping opacity-60" />}
        <span className="relative w-14 h-14 rounded-full flex items-center justify-center bg-emerald hover:bg-[#0D7338] text-white shadow-[0_10px_30px_rgba(13,115,56,0.5)] transition-all hover:-translate-y-1">
          <MessageCircle size={24} />
        </span>
      </span>
    </a>
  );
}
